import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";

import { CsvUploadService } from "../../../services/csv-upload.service";

import { FileUploader } from "ng2-file-upload";

import { Loggerservice } from "../../../services/logger-service";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common.service";

// const URL = "http://localhost:8086/api/upload";
const URL = window["omsubconfig"].businessurl + "/images/upload";
// const URL = "http://54.205.227.164:8081/images/upload";

@Component({
  selector: "app-airline-master",
  templateUrl: "./airline-master.component.html",
  styleUrls: ["./airline-master.css"]
})
export class AirlineMasterComponent implements OnInit {
  disablestatus = false;
  offSubmit = false;
  rejected = 0;
  previousData: any = [];
  auto_msg = "";
  data_present = false;
  minRemark = false;
  onlynum1 = false;
  exceedLength1 = false;
  minlength1 = false;
  notAlphabet1 = false;
  autoArray: any = [];
  onlyspaces = false;
  isApproved = false;
  hide = false;
  gotoChangeStatus = true;
  approveStatus;
  nameExist1 = false;

  aprvbtn = false;
  updateApprove = false;
  forupdate = false;
  STAT = 1;
  check = false;
  onlyspclchar = false;
  exceedLength = false;
  mincityname = false;
  onlynum = false;
  onlynumc = false;
  cnameExceed = false;
  invalidCityName = false;
  minlength = false;
  notAlphabet = false;
  nameExist = false;
  formstatusdata = [];
  searchresult = false;
  viewPageDetails: any = [];
  showApprove = false;
  viewpage = false;
  dblclick = false;
  searchlist: boolean = true;
  showList: boolean = false;
  screentitle: string = "Airline Master";
  actionmode: string = "Seacrh";
  masterparent_table = "mst_airline";
  masterparent_table_ID = "AIRLINE_ID";
  AIRLINE_CODE = "AIRLINE_CODE";
  AIRLINE_NAME = "AIRLINE_NAME";

  APPROVAL_STATUS = "APPROVAL_STATUS";
  masterParent_result_ID = "";
  dbFields = [
    this.AIRLINE_CODE,
    this.AIRLINE_NAME,
    "AIRLINE_LOGO",
    "AIRLINE_ICON",
    "STATUS"
  ];
  dbFields_edit = [
    this.AIRLINE_CODE,
    this.AIRLINE_NAME,
    "AIRLINE_LOGO",
    "AIRLINE_ICON"
  ];
  searchitem = " ";
  searchColumn = " ";
  childtables = [];
  filters = [];
  screen_details: any = [];
  search_details: any = [];
  serachtabledata: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;
  //codePattern = "^[A-Z]{1,3}$";
  namePattern = "^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$";
  // count1 = 0;
  // count2 = 0;
  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  masterUID = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  loader: any = false;
  masterroleID = "";
  masterfid = "";
  masterRAC_VIEW = "";
  masterRAC_ADD = "";
  masterRAC_EDIT = "";
  masterRAC_APROVE = "";
  masterAIRLINE_LOGO = "";
  masterAIRLINE_ICON = "";
  public uploader: FileUploader = new FileUploader({
    url: URL,
    itemAlias: "photo"
  });
  constructor(
    private vernostService: VernostServiceService,
    private csvupload: CsvUploadService,
    private logService: Loggerservice,
    private commonService : CommonService,
    private router: Router
  ) {}

  ngOnInit() {
    this.masterUID = localStorage.getItem("uid");
    this.masterroleID = localStorage.getItem("roleID");
    this.masterfid = localStorage.getItem("fid");
    // alert("fid"+this.fid);
    if (this.masterUID == "" || this.masterUID == undefined) {
      this.router.navigate(["/login"]);
    }
    var rollArray = {
      funId: this.masterfid,
      roleID: this.masterroleID
    };

    this.vernostService.checkFunAccess(rollArray).subscribe(response => {
      this.masterRAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.masterRAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.masterRAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.masterRAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      AIRLINE_CODE: "",
      AIRLINE_NAME: ""
    };
    this.search_details = {
      AIRLINE_CODE: "",
      AIRLINE_NAME: ""
    };
    this.showList = false;

    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      // this.AIRLINE_LOGO = response;
      // this.AIRLINE_ICON = response;
      this.screen_details.BANNER_IMAGE = response;
    };
  }

  checkAproval() {
    // alert("in approvol");
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    let arrayAirlineMaster = {
      dbField: dbField,
      parent_table: this.masterparent_table,
      parent_table_ID: this.masterparent_table_ID,
      formdataId: this.masterParent_result_ID
    };
    this.vernostService.checkAproval(arrayAirlineMaster).subscribe(response => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }

  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }

  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }
  changeName() {
    // alert(this.Parent_result_ID);
    var data = {
      parent_table: this.masterparent_table,
      formData: this.masterParent_result_ID,
      columnName: "AIRLINE_ID"
    };

    this.vernostService.getSTATUS(data).subscribe(response => {
      // this.approveStatus = 0;
      // this.searchData();

      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

   gotochangestatus() {
    let arr = this.commonService.gotochangestatus(this.actionmode,[this.masterparent_table,this.masterParent_result_ID, this.masterparent_table_ID]);
    this.vernostService.editstatus(arr).subscribe(res => {
      this.isApproved = false
    });
  }

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'airline-master');
  }

  aproveReject(status) {
    if (!this.nameExist1) {
      this.isApproved = true;
      var currentTime = new Date();

      var dbFieldAirlineMaster = [
        this.APPROVAL_STATUS,
        this.APPROVAL_REMARKS,
        this.APPROVAL_BY,
        "STATUS",
        "APPROVAL_DATE_TIME"
      ];
      if (status == 1) {
        this.approveStatus = 1;
      }
      var formDataAirlineMaster = [
        status,
        this.aprove_details.APPROVAL_REMARKS,
        this.masterUID,
        status,
        currentTime
      ];
      var array = {
        dbField: dbFieldAirlineMaster,
        parent_table: this.masterparent_table,
        formData: formDataAirlineMaster,
        parent_table_ID: this.masterparent_table_ID,
        formdataId: this.masterParent_result_ID
      };

      this.vernostService.aproveReject(array).subscribe(res => {
        this.aprove_details.APPROVAL_REMARKS = "";
        if (status == 2) {
          this.rejected = 2;
          this.logService.create_log_masters(
            "'Component Name':Airline Master,'Action':Reject Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );
        } else {
          if (this.isApproved && this.actionmode == "Edit") {
            this.checkColor();
          }

          if (res[0].aproval == "aproved") {
            this.aprvbtn = false;

            this.logService.create_log_masters(
              "'Component Name':Airline Master,'Action':Approve Record,'Modified by':" +
                localStorage.getItem("fname") +
                "'Record':" +
                JSON.stringify(this.screen_details),
              "info"
            );
          }
          this.aprvbtn = false;
        }
      });
      if (this.actionmode == "Edit") {
        this.submitData1();
      }
      this.searchData();
    }
  }
  setId(id) {
    this.masterParent_result_ID = id;
  }
/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    var dataAirlineMaster = {
      parent_table: this.masterparent_table,
      formData: id,
      columnName: "AIRLINE_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataAirlineMaster).subscribe(response => {
      this.searchData();
    });
  } */

  /*
  sortByOrder(data, number_airline_master) {
    if (number_airline_master == 1) {
      if (this.count1 % 2 == 0) {
        this.sortType = "ASC";
      } else {this.sortType = "DESC"; }
      this.count1++;
      this.count2 = 0;
    }
    if (number_airline_master == 2) {
      if (this.count2 % 2 == 0) {
        this.sortType = "ASC";
      } else { this.sortType = "DESC"; }
      
      this.count2++;
      this.count1 = 0;
    }
    var arrayAirlineMaster = {
      sortField: data,
      parent_table: this.masterparent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayAirlineMaster).subscribe(res => {
      this.serachtabledata = res;
    });
  } */

  addForm() {
    this.nameExist1 = false;
    this.cnameExceed = false;
    this.mincityname = false;
    this.onlynumc = false;
    this.invalidCityName = false;
    this.onlyspclchar = false;
    this.onlyspaces = false;
    this.nameExist = false;
    this.exceedLength = false;
    this.notAlphabet = false;
    this.minlength = false;
    this.onlynum = false;

    this.masterParent_result_ID = "";
    this.showList = false;
    this.actionmode = "Add";
    this.forupdate = false;
    document.getElementById("errs").innerHTML = "";
    this.updateApprove = false;
    this.masterAIRLINE_ICON = "";
  }
  openfileDialog() {
    document.getElementById("fileLoader").click();
  }
  searchForm() {
    this.nameExist1 = false;
    this.cnameExceed = false;
    this.mincityname = false;
    this.onlynumc = false;
    this.invalidCityName = false;
    this.onlyspclchar = false;
    this.onlyspaces = false;
    this.nameExist = false;
    this.exceedLength = false;
    this.notAlphabet = false;
    this.minlength = false;
    this.onlynum = false;
    if (this.actionmode != "Edit") {
      this.searchData();
    } else {
      this.search_details.AIRLINE_CODE = "";
      this.search_details.AIRLINE_NAME = "";
      this.searchresult = false;
    }

    this.updateApprove = false;
    this.screen_details = {
      AIRLINE_CODE: "",
      AIRLINE_NAME: ""
    };
    this.masterAIRLINE_ICON = "";
    this.actionmode = "Search";
    this.viewpage = false;
    this.showList = false;
    this.showApprove = false;
    this.hide = false;
    this.disablestatus = false;
    this.nameExist = false;
    this.nameExist1 = false;
    this.exceedLength1 = false;
    this.notAlphabet1 = false;
    this.onlynum1 = false;

    document.getElementById("errs").innerHTML = "";
    // if (this.forupdate) {
    //   document.getElementById("errs").innerHTML = "Record updated Successfully";

    //   setTimeout(function() {
    //     document.getElementById("errs").innerHTML = "";
    //     document.getElementById("errs").style.background = "#ebccd1";
    //     document.getElementById("errs").style.color = "#a94442";
    //   }, 3000);
    // }
  }
  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        //alert("already approved");
        this.isApproved = true;
      }
    }
    this.masterParent_result_ID = formData;
    var array = {
      parent_table: this.masterparent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.masterparent_table_ID,
      formData: formData
    };
    this.vernostService.getData(array).subscribe(response => {
      this.screen_details = {
        AIRLINE_CODE: response[0].result[0].AIRLINE_CODE,
        AIRLINE_NAME: response[0].result[0].AIRLINE_NAME,
        AIRLINE_LOGO: response[0].result[0].AIRLINE_LOGO,
        AIRLINE_ICON: response[0].result[0].AIRLINE_ICON
      };
      this.viewPageDetails = response[0].result;
      this.previousData = response[0].result;
      this.approveStatus = response[0].result[0].STATUS;

      if (toggle == "1") {
        if (!this.showApprove) {
          this.showList = true;
        } else {
          this.showList = false;
        }
        this.actionmode = "Add";
        this.viewpage = true;
      }
      if (toggle == "2") {
        // this.updateApprove = true;
        // this.showList = false;
        // this.actionmode = "Edit";
        //status,approveStatus
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  submitdata() {
    this.updateApprove = false;
    this.hide = false;
    this.disablestatus = false;
    this.offSubmit = false;

    if (
      this.screen_details.AIRLINE_CODE == "" ||
      this.screen_details.AIRLINE_NAME == ""
    ) {
      // alert("Please fill all the Field");
      document.getElementById("errs").innerHTML = "Please fill all data";

      this.dblclick = false;
    } else {
      var acode = this.screen_details.AIRLINE_CODE.toUpperCase();
      var formData = [
        acode,
        this.screen_details.AIRLINE_NAME,
        this.masterAIRLINE_LOGO,
        this.masterAIRLINE_ICON
      ];

      if (this.masterParent_result_ID != "") {
        var array = {
          parent_table: this.masterparent_table,
          dbFields: this.dbFields_edit,
          parent_table_ID: this.masterparent_table_ID,
          formData: formData,
          formdataId: this.masterParent_result_ID,
          USER_ID: this.masterUID
        };
        this.vernostService.editData(array).subscribe(response => {
          this.dblclick = false;
          this.forupdate = true;

          document.getElementById("errs").innerHTML =
            "Record upated successfully";
          this.loader = false;

          this.logService.create_log_masters(
            "'Component Name':Airline Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );
        });
      }
      if (this.masterParent_result_ID == "") {
        var Data = {
          parent_table: this.masterparent_table,
          dbFields: this.dbFields_edit,
          formData: formData,
          USER_ID: this.masterUID,
          PAGENAME: "AIRLINE"
        };

        //call webservice to save data into table

        this.vernostService.insertData(Data).subscribe(response => {
          //alert(JSON.stringify(response[0].status));
          // this.searchForm();

          document.getElementById("errs").innerHTML =
            "Record Created Successfully";

          // setTimeout(function() {
          //   document.getElementById("errs").innerHTML = "";
          //   document.getElementById("errs").style.background = "#ebccd1";
          //   document.getElementById("errs").style.color = "#a94442";
          // }, 5000);
          this.dblclick = false;
          this.viewpage = true;
          this.showList = false;
          this.showApprove = true;
          this.loader = false;
          // this.viewPageDetails.push({
          //   CITY_CODE: this.screen_details.CITY_CODE,
          //   CITY_NAME: this.screen_details.CITY_NAME,
          //   COUNTRY_NAME: this.screen_details.COUNTRY_NAME
          // });

          // this.viewPageDetails = response[0].addinfo;
          this.showFormData(response[0].addinfo, 1, 1, 1);
          this.logService.create_log_masters(
            "'Component Name':Airline Master,'Action':Create Record,'Modified by':" +
              localStorage.getItem("fname") +
              ",'Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );
        });
      }
    }
  }
  searchData() {
    this.searchlist = false;
    this.loader = true;

    var field1 = this.search_details.AIRLINE_CODE;
    var field2 = this.search_details.AIRLINE_NAME;
    if (
      (field1 == "" || field1 == undefined) &&
      (field2 == "" || field2 == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var fields1 = field1.toUpperCase();
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "" && field1 != undefined) {
        searchitem.push(fields1);
        searchColumn.push("AIRLINE_CODE");
      }
      if (field2 != "" && field2 != undefined) {
        searchitem.push(field2);
        searchColumn.push("AIRLINE_NAME");
      }

      var Data = {
        parent_table: this.masterparent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      // alert(JSON.stringify(Data));
      this.vernostService.searchRecord(Data).subscribe(res => {
        this.loader = false;

        //this.serachtabledata = res;
        if (res.length > 0) {
          this.searchresult = true;
          this.serachtabledata = res;
          document.getElementById("errs").innerHTML = "";

          this.logService.create_log_masters(
            "'Component Name':Airline Master,'Action':Srarch Record,'Modified by':" +
              localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.searchresult = false;
          document.getElementById("errs").innerHTML = "Record not found";
        }
      });
    } //   this.loadData();
  }
  fileChangeListener($event): void {
    // this.parent_table = "isd_country_master"
    this.csvupload.fileChangeListen($event, this.masterparent_table);
  }

  checkIt(data, flag) {
    this.validateNames(data);
    if (flag == 1) {
      this.checkNames();
    }
  }

  submitData1() {
    if (
      this.screen_details.AIRLINE_CODE == "" ||
      this.screen_details.AIRLINE_CODE == undefined ||
      this.screen_details.AIRLINE_NAME == "" ||
      this.screen_details.AIRLINE_NAME == undefined
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      this.loader = true;
      this.offSubmit = true;
      if (this.actionmode != "Edit") {
        this.checkNames();
      } else {
        this.onEdit_checkName();
      }
    }
  }

  onEdit_checkName() {
    if (this.actionmode == "Edit") {
      var code = this.screen_details.AIRLINE_CODE;
      var name = this.screen_details.AIRLINE_NAME;
      var table = this.masterparent_table;
      var column = "AIRLINE_NAME";
      var column1 = "AIRLINE_CODE";
      let array = {
        code: code,
        name: name,
        table: table,
        column: column,
        column1: column1
      };

      this.vernostService.checkRecordName(array).subscribe(data => {
        if (data[0].status == "success") {
          this.data_present = true;
          this.nameExist1 = true;
          this.loader = false;
        } else {
          this.data_present = false;
          if (this.offSubmit) {
            this.submitdata();
          }
        }
      });
    }
  }

  checkNames() {
    if (
      this.screen_details.AIRLINE_CODE != "" &&
      this.screen_details.AIRLINE_CODE != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "AIRLINE_CODE",
          dbFieldName: this.screen_details.AIRLINE_CODE.toUpperCase(),
          parent_table: this.masterparent_table
        };
        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.checkNames1();
            }
          } else {
            this.nameExist = true;
            this.loader = false;
          }
        });
      }
    }
  }

  checkNames1() {
    if (
      this.screen_details.AIRLINE_NAME != "" &&
      this.screen_details.AIRLINE_NAME != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "AIRLINE_NAME",
          dbFieldName: this.screen_details.AIRLINE_NAME,
          parent_table: this.masterparent_table
        };
        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist1 = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist1 = true;
            this.loader = false;
          }
        });
      }
    }
  }

  validateNames(data) {
    if (data.length == 0) {
      this.minlength = false;
      this.onlynum = false;
    } else {
      if (data.length <= 1) {
        this.minlength = true;
      } else {
        this.minlength = false;
      }

      var regx = /(?!^\d+$)^.+$/;
      var onlyNumber = regx.test(data);

      if (!onlyNumber) {
        this.onlynum = true;
      } else {
        this.onlynum = false;
      }
    }
  }

  checkIt1(data) {
    if (data.length == 0) {
      this.minlength1 = false;
      this.onlynum1 = false;
    } else {
      if (data.length <= 1) {
        this.minlength1 = true;
      } else {
        this.minlength1 = false;
      }

      var regx = /(?!^\d+$)^.+$/;
      var onlyNumber = regx.test(data);

      if (!onlyNumber) {
        this.onlynum1 = true;
      } else {
        this.onlynum1 = false;
      }
    }
  }

  checkLength1(data) {
    if (data.length == 0) {
      this.notAlphabet1 = false;
      this.exceedLength1 = false;
      this.minlength1 = false;
    } else {
      this.onlynum1 = false;
      this.exceedLength1 = false;
      this.minlength1 = false;
      this.notAlphabet1 = false;

      document.getElementById("errs").innerHTML = "";
      // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
      var regx = /^[a-zA-Z0-9]+$/;
      var checkAlphabet = regx.test(data);

      if (data.length > 2) {
        this.exceedLength1 = true;
        this.minlength1 = false;
      } else {
        this.exceedLength1 = false;
      }
      if (!checkAlphabet) {
        this.notAlphabet1 = true;
      } else {
        this.notAlphabet1 = false;
      }
    }
  }

  checkLength(data) {
    this.nameExist = false;
    if (data.length == 0) {
      this.notAlphabet = false;
      this.exceedLength = false;
      this.minlength = false;
    } else {
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }
      this.onlynum = false;
      this.exceedLength = false;
      this.minlength = false;
      this.notAlphabet = false;

      document.getElementById("errs").innerHTML = "";
      // var checkAlphabet = new RegExp("/^[A-Za-z]+$/").test(this.data);
      var regx = /^[a-zA-Z0-9]+$/;
      var checkAlphabet = regx.test(data);

      if (data.length > 2) {
        this.exceedLength = true;
        this.minlength = false;
      } else {
        this.exceedLength = false;
      }
      if (!checkAlphabet) {
        this.notAlphabet = true;
      } else {
        this.notAlphabet = false;
      }
    }
  }
  getFileDetails(event, type) {
    for (var i = 0; i < event.target.files.length; i++) {
      var name = event.target.files[i].name;
      if (type == "logo") {
        this.masterAIRLINE_LOGO = name;
        this.uploader.uploadAll();
      }
      if (type == "icon") {
        this.masterAIRLINE_ICON = name;
        this.uploader.uploadAll();
      }
    }
  }
  autoCompleteSearch(event) {
    // parentTableName = "mst_country";
    var data = {
      inputSearchString: event,
      parentTableName: "mst_airline",
      searchDBColumnName: ["AIRLINE_NAME", "AIRLINE_CODE"],
      like: "AIRLINE_NAME"
    };
    if (event.length < 3) {
      this.auto_msg = "";
    }
    if (event.length >= 3) {
      this.vernostService.getRecords(data).subscribe(response => {
        this.formstatusdata = [];
        this.autoArray = response;

        let value = new Array();
        for (let i = 0; i < this.autoArray.length; i++) {
          value[i] = {
            value: this.autoArray[i].AIRLINE_NAME,
            label: this.autoArray[i].AIRLINE_NAME
          };
          this.formstatusdata = value.slice(0);
        }

        if (this.autoArray.length <= 0 && event.length >= 3) {
          this.auto_msg = "No result found";
        } else {
          this.auto_msg = "";
        }
      });
    } else {
      this.formstatusdata = [];
    }
  }

  checkAirlineName(data) {
    this.nameExist1 = false;
    this.data_present = false;
    this.onlyspaces = false;
    if (data.length == 0) {
      this.onlynumc = false;
      this.mincityname = false;
      this.cnameExceed = false;
      this.invalidCityName = false;
      this.onlyspaces = false;
    } else {
      if (this.actionmode == "Edit") {
        this.isApproved = false;
      }

      this.onlynumc = false;
      if (data.length >= 3) {
        this.mincityname = false;
      }

      var regx = /^[^-\s][a-zA-Z0-9"!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"\s]{0,100}$/;
      var checkname = regx.test(data);
      if (data.length > 100) {
        this.cnameExceed = true;
      } else {
        this.cnameExceed = false;
        if (!checkname) {
          this.invalidCityName = true;
        } else {
          this.invalidCityName = false;
        }
      }
    }
  }

  onBlurAirline(data) {
    this.onEdit_checkName();
    if (data.length == 0) {
      this.mincityname = false;
      this.onlynumc = false;
      this.onlyspclchar = false;
      this.onlyspaces = false;
    } else {
      var space_reg = /^[ ]+$/;
      var onlyspace = space_reg.test(data);
      if (onlyspace) {
        this.onlyspaces = true;
      }

      if (data.length < 2) {
        this.mincityname = true;
      } else {
        this.mincityname = false;
        var regx = /(?!^\d+$)^.+$/;
        var onlyNumber = regx.test(data);

        if (!onlyNumber) {
          this.onlynumc = true;
        } else {
          this.onlynumc = false;
        }

        var regsx = /^[!@#$%^&*(),.?":{}|<>]+$/;
        var onlyspecialchar = regsx.test(data);

        if (onlyspecialchar) {
          this.onlyspclchar = true;
        } else {
          this.onlyspclchar = false;
        }
      }
    }
  }
  airline_url = window["omsubconfig"].businessurl + "/fetchimage?name=";
  getImage(val) {
    if (val == undefined) {
      return "../../assets/img/plain-white-background.jpg";
    } else {
      return this.airline_url + val + ".png";
    }
  }
}
